import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

export const APP_DISPLAY_NAME = 'Cardapio Chef';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(routerState: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(routerState)?.trim();
    if (pageTitle) {
      this.title.setTitle(`${pageTitle} | ${APP_DISPLAY_NAME}`);
    } else {
      this.title.setTitle(APP_DISPLAY_NAME);
    }
  }
}
